
<template>
    <div>
        <div v-if="theme === 'default'" class="bg-office-primary h-32">
            <div class="grid grid-cols-3 mx-8 h-full">
                <div class="my-auto">
                    <img class="h-12" src="/files/logo-2021-white.png" alt="logo"/>
                </div>

                <div></div>

                <div
                    class="my-auto text-3xl uppercase font-bold tracking-wide text-right text-gray-800">
                    {{ floor }}
                </div>
            </div>
        </div>

        <div v-if="theme === 'spk-leipzig'"  style="background: #fe0000" class="h-32">
            <div class="grid grid-cols-3 mx-8 h-full">
                <div class="my-auto">
                    <img class="h-32" src="/files/spk-leipzig-logo.gif" alt="logo"/>
                </div>

                <div></div>

                <div
                    class="my-auto ml-auto mr-0">
                    <img class="h-12" src="/files/officeefficient_weiss_rgb.png" alt="logo"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "FloorEventsPanelHeader",

    props: ['floor', 'theme'],
}
</script>

<style scoped>
/* Background */
.bg-office-primary {
    background-color: #f8b241;
}

/* Layout */
.grid {
    display: -ms-grid;
    display: grid;
}
.grid-cols-3 {
    -ms-grid-columns: (minmax(0, 1fr))[3];
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

/* Sizing */
.h-32 {
    height: 8rem;
}
.h-12 {
    height: 3rem;
}
.h-full {
    height: 100%;
}

/* Spacing */
.mx-8 {
    margin-left: 2rem;
    margin-right: 2rem;
}
.my-auto {
    margin-top: auto;
    margin-bottom: auto;
}
.ml-auto {
    margin-left: auto;
}
.mr-0 {
    margin-right: 0;
}

/* Typography */
.text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
}
.uppercase {
    text-transform: uppercase;
}
.font-bold {
    font-weight: 700;
}
.tracking-wide {
    letter-spacing: 0.025em;
}
.text-right {
    text-align: right;
}
.text-gray-800 {
    color: #1f2937;
}
</style>